module.exports = __webpack_public_path__ + "static/media/cards.777ff1d4.png";